import PaddedMaxWidthContainer from 'components/layout/PaddedMaxWidthContainer';
import LoadingSpinner from 'components/LoadingSpinner';
import { ASSET_PREFIX } from 'utils/constants';
import PrizeCardWithTitleBelow from '../PrizeCardWithTitleBelow';
import PrizeList from '../PrizeList';
import SectionHeading from '../SectionHeading';
import TrendingPrizeCard from '../TrendingPrizeCard';

type TPrize = {
  id: number;
  slug: string;
  title: string;
  subheading: string;
  heroImageLocation: string;
};

type TPrizesGrouped = {
  HERO: TPrize[];
  TRENDING_GRID: TPrize[];
  ALL: TPrize[];
};

interface IRedemptionFlowProps {
  prizes: TPrizesGrouped | null;
  handleSelectPrize: (slug: string) => Promise<void>;
}

export const RedemptionFlow = ({
  prizes,
  handleSelectPrize,
}: IRedemptionFlowProps) => {
  if (!prizes) {
    return <LoadingSpinner loadingText={undefined} style={undefined} />;
  }
  return (
    <>
      {/* TRENDING PRIZES SECTION */}
      <PaddedMaxWidthContainer
        style={{
          margin: '5px 0 0 0',
          width: '100%',
          maxWidth: '100%',
          background: '#F6F6F6',
        }}
      >
        {/* HERO PRIZE */}
        {prizes['HERO']?.length > 0 && (
          <div className="trendingPrizesContainer">
            <TrendingPrizeCard
              prize={prizes['HERO'][0]} // only one hero card
              isHeroCard
              onClick={() => handleSelectPrize(prizes['HERO'][0].slug)}
            />
          </div>
        )}

        {/* SMALLER TRENDING GRID PRIZES */}
        {prizes['TRENDING_GRID']?.length > 0 && (
          <div className="trendingPrizesGrid">
            {prizes['TRENDING_GRID'].map((prize) => (
              <TrendingPrizeCard
                key={prize.slug}
                prize={prize}
                onClick={() => handleSelectPrize(prize.slug)}
                isHeroCard={undefined}
              />
            ))}
          </div>
        )}
      </PaddedMaxWidthContainer>

      {/* ALL PRIZES SECTION */}
      {prizes['ALL']?.length > 0 && (
        <PaddedMaxWidthContainer
          style={{ margin: 0, width: '100%', maxWidth: '100%' }}
        >
          {(prizes['HERO']?.length > 0 ||
            prizes['TRENDING_GRID']?.length > 0) && ( // Only show "Pin to the top" heading if the Trending Prizes section above is shown
            <SectionHeading
              iconSrc={`${ASSET_PREFIX}/images/prizes/magnifying-glass.svg`}
              title="Browse All"
              style={{
                padding: '3em 1em',
                background: 'white',
              }}
              subheading={undefined}
            />
          )}

          <PrizeList
            pageSize={6}
            style={{
              maxWidth: 1100,
            }}
          >
            {prizes['ALL']?.length > 0 &&
              prizes['ALL'].map((prize) => (
                <PrizeCardWithTitleBelow
                  key={prize.slug}
                  prize={prize}
                  onClick={() => handleSelectPrize(prize.slug)}
                  showPrizeTierBadge={false}
                  withFavouriteButton={true}
                  showLockedPrizeBannerIfApplicable={false}
                />
              ))}
          </PrizeList>
        </PaddedMaxWidthContainer>
      )}
    </>
  );
};
